import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";



/**CSS ****/
import "./assets/styles/custom.css";
import "./assets/styles/font-awesome.min.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";




//import Header from "./components/Layout/header";
//import Footer from "./components/Layout/footer";
import AppRoutes from "./router/routes";
import useEventData from "./hooks/useEventData";
import PageNotFound from "./pages/pageNotFound.tsx";
import Loader from "./components/common/Loader.tsx";

const App: React.FC = () => {
const [isLoading, setIsLoading] = useState(true); // Track loading state
const [isDataReady, setIsDataReady] = useState(false); // Track data readiness

const { eventData, loadEventData } = useEventData();
  

  useEffect(() => {
    // Load event data on page load
    const fetchData = async () => {
      setIsLoading(true);
      await loadEventData(); // Fetch data
      setIsLoading(false); // Mark loading as complete
    };

    fetchData();
  }, [loadEventData]);

  useEffect(() => {
    // Check if eventData is ready
    if (eventData && Object.keys(eventData).length > 0) {
      setIsDataReady(true);
    } else {
      setIsDataReady(false);
    }
  }, [eventData]);

  // Render loading state
  if (isLoading) {
    <Loader/>
  }

  // Render the main app
  return (
    <Router>
      {isDataReady ? <AppRoutes /> : <Loader />}
  </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <Provider store={store}>
          <App />
    </Provider>
);